import styled from 'styled-components'

export const ModalActions = styled.div`
  display: flex;
  gap: 16px;
  margin-top: 16px;

  > * {
    flex: 1;
  }
`
